// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__CgdPH","children":"PageHeader_children__W-AEu"};